<template>
    <v-menu v-model="openfilters" location="bottom" content-class="ui-menu kyano-menu" :close-on-content-click="false"
        offset-y contained>
        <template #activator="{ props }">
            <v-btn v-bind="props" class="ui-btn ui-btn-icon" v-if="filters.length">
                <ui-icon name="filter" />
            </v-btn>
        </template>

        <div class="ui-card filter-card">
            <collapse-section v-for="(filter, index) in filters" :key="index" class="my-1"
                :title="stripHtml(filter.name)" :open="index === 0">
                <div class="px-1">
                    <!-- Checkboxes -->
                    <div v-if="filter.type === 'checkbox'">
                        <div v-for="option in getFieldOptions(filter.selected_field)" :key="option"
                            class="ui-checkbox-flex">
                            <label class="ui-label ui-label-sm">{{ option }}</label>
                            <div class="checkbox-vue">
                                <v-checkbox v-model="filterValues[filter.selected_field]" :value="option" hide-details
                                    density="compact" color="var(--ui-accent-primary)" />
                            </div>
                        </div>
                    </div>

                    <!-- Radio -->
                    <div v-else-if="filter.type === 'radio'">
                        <v-radio-group v-model="filterValues[filter.selected_field]" hide-details>
                            <div v-for="option in getFieldOptions(filter.selected_field)" :key="option"
                                class="ui-checkbox-flex text-left">
                                <label class="ui-label ui-label-sm">{{ option }}</label>
                                <div class="checkbox-vue">
                                    <v-radio :value="option" color="var(--ui-accent-primary)" />
                                </div>
                            </div>
                        </v-radio-group>
                    </div>

                    <!-- Select -->
                    <div v-else-if="filter.type === 'select'">
                        <v-select v-model="filterValues[filter.selected_field]" class="ui-select"
                            :items="getFieldOptions(filter.selected_field)" placeholder="Selecteer een optie"
                            variant="solo" density="compact" hide-details :menu-props="{ class: 'kyano-menu' }" />
                    </div>
                </div>
            </collapse-section>

            <div class="d-flex flex flex-wrap ga-2 justify-end pa-3">
                <v-btn @click="clearfilter" class="ui-btn ui-btn-accent-secondary">
                    Reset filter
                </v-btn>
                <v-btn class="ui-btn ui-btn-accent-primary" @click="applyInAppFilter">
                    Filteren
                </v-btn>
            </div>
        </div>
    </v-menu>
</template>

<script>
export default {
    props: {
        filters: { type: Array, default: () => [] },
        collection_data: { type: Array, default: () => [] },
    },
    data() {
        return {
            openfilters: false,
            filterValues: {}, // <-- waarden van de filters
        };
    },
    methods: {
        // getFieldOptions(field) {
        //     const values = new Set();
        //     this.collection_data.forEach((item) => {
        //         const value = item[field];
        //         console.log("item:", item, "field:", field, "value:", value); // <--- DEBUG!
        //         if (Array.isArray(value)) {
        //             value.forEach((v) => values.add(v));
        //         } else if (value !== undefined && value !== null) {
        //             values.add(value);
        //         }
        //     });
        //     return Array.from(values);
        // },
        getFieldOptions(field) {
            const values = new Set();
            this.collection_data.forEach((item) => {
                const value = item[field];
                if (Array.isArray(value)) {
                    value.forEach((v) => values.add(v));
                } else if (value !== undefined && value !== null) {
                    values.add(value);
                }
            });
            return Array.from(values);
        },
        clearfilter() {
            Object.keys(this.filterValues).forEach((key) => {
                if (Array.isArray(this.filterValues[key])) {
                    this.filterValues[key] = [];
                } else {
                    this.filterValues[key] = "";
                }
            });
        },
        applyInAppFilter() {
            this.$emit("apply-filters", this.filterValues);
        },
        stripHtml(html) {
            const div = document.createElement("div");
            div.innerHTML = html;
            return div.textContent || div.innerText || "";
        },
        initFilterValues() {
            this.filters.forEach((filter) => {
                const field = filter.selected_field;
                if (filter.type === "checkbox" || filter.type === "select") {
                    if (!Array.isArray(this.filterValues[field])) {
                        this.filterValues[field] = [];
                    }
                } else if (filter.type === "radio") {
                    this.filterValues[field] = ""; // Zorg dat dit een string is
                }
            });
        },
    },
    mounted() {
        this.initFilterValues();
    },
};
</script>
